import { getConfig } from '../configure/utils';
export default getConfig;
